/* Contact : le lien de la page Collaborations (?sujet=collaboration) préremplit le champ « Sujet » (maquette : prefillSubject de js/pages.js). Ne remplace jamais ce que la personne a écrit. */
const input = document.querySelector('input[data-subject-collaboration]');
if (input) {
  const subject = new URLSearchParams(location.search).get('sujet');
  if (subject === 'collaboration' && !input.value) input.value = input.dataset.subjectCollaboration || '';
}
